import { render, staticRenderFns } from "./ResourceLibraryFrom.vue?vue&type=template&id=458cacd2"
import script from "./ResourceLibraryFrom.vue?vue&type=script&lang=js"
export * from "./ResourceLibraryFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports